import { Image } from 'antd-mobile';
import './index.less'
import { isMobile } from '@/utils/common'
// 图片
import phone_company_info from '@/image/AboutUs/phone_company_info.png'
import company_info from '@/image/AboutUs/company_info.png'
// 组件
import WebInfo from '@/component/WebInfo/index'

const AboutUs = () => {
  return (
    <div className='about-us-page'>
      <header>
        <h1>公司简介</h1>
        <p>OUR COMPANY</p>
      </header>

      <p>悠悦软件是运动预约信息服务平台，致力于为每个用户提供专业的私人教练服务。</p>
      <p>小香风产品是一款全方位多领域教练，一站式预约的应用，用于帮助用户告别盲目自学，与专业教练相遇，提升用户技能，遇见兴趣爱好相同的朋友。</p>
      <p>在这里严选好教练，专业有保障，无论你是想入门、进阶还是精进，总有教练适合你；汇聚各领域教练，多品类、多教练随心选，一站式预约心仪的运动教练，轻松安排运动计划。</p>

      <Image src={isMobile() ? phone_company_info : company_info} className='Introduction' fit='contain' />

      <WebInfo />
    </div>
  )
}

export default AboutUs